/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

import { isError } from "@epic-mw/error-types";

import { getApiPath } from "../utils";

export interface AuthRes {
	bearerTokenValid: boolean;
	clearedOffline: boolean;
	accountId: string;
	upgradedBearerToken: boolean;
}

export const auth = async (): Promise<AuthRes> => {
	try {
		const response = await fetch(`${getApiPath()}/auth`);
		const json: AuthRes = await response.json();
		return json;
	} catch (err) {
		console.error("auth() failed to load", isError(err) && err.message);
		throw err;
	}
};
